// extracted by mini-css-extract-plugin
export default {"wapper":"SelectMutiple_wapper__mo5g3","chipItem":"SelectMutiple_chipItem__YAzlo"};